import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export const errorMessages = {
  "auth/admin-restricted-operation": {
    en: "This operation is restricted to administrators.",
    ro: "Această operațiune este restricționată administratorilor.",
    es: "Esta operación está restringida a los administradores."
  },
  "auth/argument-error": {
    en: "Invalid arguments provided.",
    ro: "Argumente invalide furnizate.",
    es: "Se han proporcionado argumentos no válidos."
  },
  "auth/captcha-check-failed": {
    en: "Google reCAPTCHA check failed.",
    ro: "Verificarea Google reCAPTCHA a eșuat.",
    es: "La verificación de Google reCAPTCHA ha fallado."
  },
  "auth/code-expired": {
    en: "The provided code has expired.",
    ro: "Codul furnizat a expirat.",
    es: "El código proporcionado ha expirado."
  },
  "auth/cors-unsupported": {
    en: "CORS is not supported by your browser.",
    ro: "CORS nu este acceptat de browserul tău.",
    es: "CORS no es compatible con tu navegador."
  },
  "auth/credential-already-in-use": {
    en: "This credential is already associated with another account.",
    ro: "Această acreditare este deja asociată cu un alt cont.",
    es: "Estas credenciales ya están asociadas con otra cuenta."
  },
  "auth/custom-token-mismatch": {
    en: "The custom token and API key do not match.",
    ro: "Tokenul personalizat și cheia API nu se potrivesc.",
    es: "El token personalizado y la clave de API no coinciden."
  },
  "auth/requires-recent-login": {
    en: "Please login again, as your last login was too long ago.",
    ro: "Te rugăm să te autentifici din nou, deoarece ultima autentificare a fost prea demult.",
    es: "Por favor, inicia sesión nuevamente, ya que tu última sesión fue hace demasiado tiempo."
  },
  "auth/dependent-sdk-initialized-before-auth": {
    en: "Please initialize the Firebase Auth SDK before other dependent SDKs.",
    ro: "Te rugăm să inițializezi Firebase Auth SDK înaintea altor SDK-uri dependente.",
    es: "Por favor, inicializa el SDK de Firebase Auth antes que otros SDK dependientes."
  },
  "auth/dynamic-link-not-activated": {
    en: "Dynamic links are not activated.",
    ro: "Linkurile dinamice nu sunt activate.",
    es: "Los enlaces dinámicos no están activados."
  },
  "auth/email-change-needs-verification": {
    en: "Please verify your new email address.",
    ro: "Te rugăm să verifici noua ta adresă de email.",
    es: "Por favor, verifica tu nueva dirección de correo electrónico."
  },
  "auth/email-already-in-use": {
    en: "The email address is already in use.",
    ro: "Adresa de email este deja utilizată.",
    es: "La dirección de correo electrónico ya está en uso."
  },
  "auth/emulator-config-failed": {
    en: "Emulator configuration failed.",
    ro: "Configurarea emulatorului a eșuat.",
    es: "La configuración del emulador ha fallado."
  },
  "auth/expired-action-code": {
    en: "The action code has expired.",
    ro: "Codul de acțiune a expirat.",
    es: "El código de acción ha expirado."
  },
  "auth/cancelled-popup-request": {
    en: "The popup request has been cancelled.",
    ro: "Cererea de fereastră pop-up a fost anulată.",
    es: "La solicitud de ventana emergente ha sido cancelada."
  },
  "auth/internal-error": {
    en: "An internal error has occurred.",
    ro: "A apărut o eroare internă.",
    es: "Se ha producido un error interno."
  },
  "auth/invalid-user-token": {
    en: "Invalid user token.",
    ro: "Token-ul utilizatorului este invalid.",
    es: "El token del usuario no es válido."
  },
  "auth/invalid-auth-event": {
    en: "Invalid authentication event.",
    ro: "Evenimentul de autentificare este invalid.",
    es: "El evento de autenticación no es válido."
  },
  "auth/invalid-verification-code": {
    en: "The provided verification code is invalid.",
    ro: "Codul de verificare furnizat este invalid.",
    es: "El código de verificación proporcionado no es válido."
  },
  "auth/invalid-continue-uri": {
    en: "The continue URL is invalid.",
    ro: "URL-ul de continuare este invalid.",
    es: "La URL de continuación no es válida."
  },
  "auth/invalid-email": {
    en: "Invalid email address.",
    ro: "Adresă de email invalidă.",
    es: "Dirección de correo electrónico no válida."
  },
  "auth/invalid-credential": {
    en: "Invalid credentials.",
    ro: "Credentiale invalide.",
    es: "Credenciales no válidas."
  },
  "auth/invalid-message-payload": {
    en: "Invalid message payload.",
    ro: "Conținut de mesaj invalid.",
    es: "Carga útil del mensaje no válida."
  },
  "auth/invalid-multi-factor-session": {
    en: "Invalid multi-factor authentication session.",
    ro: "Sesiune de autentificare multi-factor invalidă.",
    es: "Sesión de autenticación multifactor no válida."
  },
  "auth/invalid-action-code": {
    en: "The reset password action code is invalid.",
    ro: "Codul de resetare a parolei este invalid.",
    es: "El código de acción para restablecer la contraseña no es válido."
  },
  "auth/wrong-password": {
    en: "Incorrect password.",
    ro: "Parolă incorectă.",
    es: "Contraseña incorrecta."
  },
  "auth/invalid-phone-number": {
    en: "Invalid phone number.",
    ro: "Număr de telefon invalid.",
    es: "Número de teléfono no válido."
  },
  "auth/invalid-recipient-email": {
    en: "Invalid recipient email.",
    ro: "Adresă de email destinatar invalidă.",
    es: "Dirección de correo electrónico del destinatario no válida."
  },
  "auth/invalid-sender": {
    en: "Invalid sender.",
    ro: "Expeditor invalid.",
    es: "Remitente no válido."
  },
  "auth/invalid-verification-id": {
    en: "Invalid verification ID.",
    ro: "ID de verificare invalid.",
    es: "ID de verificación no válido."
  },
  "auth/multi-factor-info-not-found": {
    en: "Multi-factor authentication information not found.",
    ro: "Informațiile de autentificare multi-factor nu au fost găsite.",
    es: "Información de autenticación multifactor no encontrada."
  },
  "auth/multi-factor-auth-required": {
    en: "Multi-factor authentication is required.",
    ro: "Autentificarea multi-factor este necesară.",
    es: "Se requiere autenticación multifactor."
  },
  "auth/missing-multi-factor-info": {
    en: "Missing multi-factor authentication information.",
    ro: "Lipsesc informațiile de autentificare multi-factor.",
    es: "Falta información de autenticación multifactor."
  },
  "auth/missing-multi-factor-session": {
    en: "Missing multi-factor authentication session.",
    ro: "Lipsesc sesiunea de autentificare multi-factor.",
    es: "Falta la sesión de autenticación multifactor."
  },
  "auth/missing-phone-number": {
    en: "Missing phone number.",
    ro: "Lipsesc numărul de telefon.",
    es: "Falta el número de teléfono."
  },
  "auth/missing-verification-id": {
    en: "Missing verification ID.",
    ro: "Lipsesc ID-ul de verificare.",
    es: "Falta el ID de verificación."
  },
  "auth/account-exists-with-different-credential": {
    en: "An account with this email already exists with a different credential.",
    ro: "Un cont cu această adresă de email există deja cu alte credențiale.",
    es: "Ya existe una cuenta con este correo electrónico y credenciales diferentes."
  },
  "auth/null-user": {
    en: "No user is currently signed in.",
    ro: "Nu există niciun utilizator conectat în prezent.",
    es: "No hay ningún usuario actualmente conectado."
  },
  "auth/no-auth-event": {
    en: "No authentication event.",
    ro: "Niciun eveniment de autentificare.",
    es: "No hay evento de autenticación."
  },
  "auth/operation-not-allowed": {
    en: "This operation is not allowed.",
    ro: "Această operațiune nu este permisă.",
    es: "Esta operación no está permitida."
  },
  "auth/operation-not-supported-in-this-environment": {
    en: "This operation is not supported in your current environment.",
    ro: "Această operațiune nu este suportată în mediul tău curent.",
    es: "Esta operación no es compatible con tu entorno actual."
  },
  "auth/popup-blocked": {
    en: "Popup blocked by the browser.",
    ro: "Popup-ul a fost blocat de browser.",
    es: "Popup bloqueado por el navegador."
  },
  "auth/popup-closed-by-user": {
    en: "Popup closed by user.",
    ro: "Popup-ul a fost închis de utilizator.",
    es: "Popup cerrado por el usuario."
  },
  "auth/provider-already-linked": {
    en: "This provider is already linked to your account.",
    ro: "Acest furnizor este deja legat de contul tău.",
    es: "Este proveedor ya está vinculado a tu cuenta."
  },
  "auth/quota-exceeded": {
    en: "Quota exceeded.",
    ro: "Cotele au fost depășite.",
    es: "Cuota excedida."
  },
  "auth/redirect-cancelled-by-user": {
    en: "Redirect cancelled by user.",
    ro: "Redirecționarea a fost anulată de utilizator.",
    es: "Redirección cancelada por el usuario."
  },
  "auth/redirect-operation-pending": {
    en: "Redirect operation is pending.",
    ro: "Operațiunea de redirecționare este în așteptare.",
    es: "Operación de redirección pendiente."
  },
  "auth/rejected-credential": {
    en: "Rejected credential.",
    ro: "Credențialul a fost respins.",
    es: "Credencial rechazada."
  },
  "auth/second-factor-already-in-use": {
    en: "Second factor authentication method already in use.",
    ro: "Metoda de autentificare cu al doilea factor este deja în uz.",
    es: "El método de autenticación de segundo factor ya está en uso."
  },
  "auth/maximum-second-factor-count-exceeded": {
    en: "Maximum number of second factor methods exceeded.",
    ro: "Numărul maxim de metode de al doilea factor a fost depășit.",
    es: "Se ha superado el número máximo de métodos de segundo factor."
  },
  "auth/user-disabled": {
    en: "User account is disabled.",
    ro: "Contul utilizatorului este dezactivat.",
    es: "La cuenta de usuario está deshabilitada."
  },
  "auth/user-mismatch": {
    en: "User mismatch.",
    ro: "Neconcordanță utilizator.",
    es: "Desajuste de usuario."
  },
  "auth/user-signed-out": {
    en: "User has signed out.",
    ro: "Utilizatorul s-a deconectat.",
    es: "El usuario ha cerrado sesión."
  },
  "auth/weak-password": {
    en: "Password must be more complex.",
    ro: "Parola trebuie să fie mai complicată.",
    es: "La contraseña debe ser más compleja."
  },
  "auth/recaptcha-not-enabled": {
    en: "Google reCAPTCHA is not enabled.",
    ro: "Google reCAPTCHA nu este activat.",
    es: "Google reCAPTCHA no está habilitado."
  },
  "auth/missing-recaptcha-token": {
    en: "Missing Google reCAPTCHA token.",
    ro: "Lipseste token-ul Google reCAPTCHA.",
    es: "Falta el token de Google reCAPTCHA."
  },
  "auth/invalid-recaptcha-token": {
    en: "Invalid Google reCAPTCHA token.",
    ro: "Token-ul Google reCAPTCHA este invalid.",
    es: "Token de Google reCAPTCHA inválido."
  },
  "auth/invalid-recaptcha-action": {
    en: "Invalid Google reCAPTCHA action.",
    ro: "Acțiunea Google reCAPTCHA este invalidă.",
    es: "Acción de Google reCAPTCHA inválida."
  },
  "auth/missing-recaptcha-version": {
    en: "Missing Google reCAPTCHA version.",
    ro: "Lipseste versiunea Google reCAPTCHA.",
    es: "Falta la versión de Google reCAPTCHA."
  },
  "auth/invalid-recaptcha-version": {
    en: "Invalid Google reCAPTCHA version.",
    ro: "Versiunea Google reCAPTCHA este invalidă.",
    es: "Versión de Google reCAPTCHA inválida."
  },
  "auth/invalid-req-type": {
    en: "Invalid request type.",
    ro: "Tipul de cerere este invalid.",
    es: "Tipo de solicitud inválido."
  }
}

export const getFirebaseErrorMessage = (key, lang = "en") => {
  return errorMessages[key]?.[lang] || errorMessages[key]?.en || key;
};